/** Manage mode defines if the application is either in public or admin mode */
export const manageModeSelector = state => state.environment.manageMode || 'public';

/** Manage type defines if the application is either in content or template mode */
export const manageTypeSelector = state => state.environment.manageType || 'content';

export const getUserAgent = state => state.environment.userAgent;

export const getContent = state => state.environment.content;

